export const propertyStructure = Object.freeze({
  Id: { label: 'Id', isFull: false, isRequired: false },
  Tag: { label: '棟別', isFull: false, isRequired: false },
  TabletNote: { label: '戶別', isFull: false, isRequired: false },
  Address: { label: '門牌地址', isFull: false, isRequired: true, maxLength: 100 },
  PartArea: { label: '專有部分面積', isFull: false, isRequired: false },
  ShareArea: { label: '共用部分面積', isFull: false, isRequired: false },
  TotalArea: { label: '總面積', isFull: false, isRequired: false },
  OwnershipRatio: { label: '所有權比例', isFull: false, isRequired: false },
  OwnershipHolderName: { label: '區權人', isFull: false, isRequired: false, maxLength: 10 },
  OwnershipHolderPhone: { label: '電話', isFull: false, isRequired: false, maxLength: 15 },
  Note: { label: '備註', isFull: true, isRequired: false, maxLength: 50 }
})

export const householdDetailStructure = Object.freeze({
  ResidentName: { label: '住戶名稱', maxLength: 10 },
  IdentityName: { label: '住戶身份', maxLength: null },
  MobilePhoneNumber: { label: '行動電話', maxLength: 10 },
  LocalPhoneNumber: { label: '室內電話', maxLength: 15 },
  EmergencyContactName: { label: '緊急聯絡人', maxLength: 10 },
  EmergencyContactPhone: { label: '緊急聯絡人電話', maxLength: 10 },
  Car: { label: '汽車車牌號', maxLength: null },
  Scooter: { label: '機車車牌號', maxLength: null },
  Note: { label: '備註', maxLength: 50 }
})
